import { AudienceBroadcastMessagesFilter, AudienceBroadcastMessageType } from '@occc/graphql';
import { getDateRange } from '@occc/ui-forms';

import { MessagingCampaignsFilterFormValues } from './messaging-campaigns-filter.types';

import { notArchivedStatuses } from '../../messaging-campaigns-list.constants';

export const messagingCampaignsFilterToGqlFilter = (
  input: MessagingCampaignsFilterFormValues,
): AudienceBroadcastMessagesFilter => {
  let baseFilter: AudienceBroadcastMessagesFilter = {};

  if (input.search) {
    baseFilter.search = input.search;
  }

  if (input.messageTypeEquals) {
    const messageTypeMapping: Record<string, AudienceBroadcastMessageType[]> = {
      SMS: [AudienceBroadcastMessageType.Sms],
      PUSH: [AudienceBroadcastMessageType.Push],
      BOTH: [AudienceBroadcastMessageType.Sms, AudienceBroadcastMessageType.Push],
    };
    baseFilter.messageTypeIncludes = messageTypeMapping[input.messageTypeEquals] || [];
  }

  if (input.statusEquals) {
    baseFilter.statusIncludes = [input.statusEquals];
  } else {
    baseFilter.statusIncludes = notArchivedStatuses;
  }

  if (input.scheduledAt) {
    baseFilter = {
      ...baseFilter,
      ...getDateRange(
        input.scheduledAt,
        'scheduledDateFrom',
        'scheduledDateTo',
        input.scheduledDateFrom,
        input.scheduledDateTo,
      ),
    };
  }

  return baseFilter;
};
